import {
  SAFETY_CENTRE_LOCALES,
  SHIPPING_LOCALES,
  SupportedLocation,
} from '../location/constants';

import { HELP_ARTICLES } from '@/constants/helpUrls.ts';

export const FooterUpperConfig = [
  {
    title: 'Nav.Depop',
    children: [
      {
        text: 'Nav.AboutUs',
        linkAddress: 'https://news.depop.com/who-we-are/about/',
      },
      {
        text: 'Nav.Careers',
        linkAddress: 'https://depopcareers.com/',
      },
      {
        text: 'Nav.Blog',
        linkAddress: '/blog/',
      },
      {
        text: 'Nav.News',
        linkAddress: 'https://news.depop.com/',
      },
      {
        text: 'Nav.Impact',
        linkAddress: 'https://news.depop.com/impact/',
      },
    ],
  },
  {
    title: 'Nav.Sell',
    children: [
      {
        text: 'Nav.SellOnDepop',
        linkAddress: '/sell/',
      },
      {
        text: 'Nav.DepopShipping',
        linkAddress: '/shipping/',
        locations: SHIPPING_LOCALES,
      },
      {
        text: 'Nav.DepopAffiliates',
        linkAddress: '/partners/depop-affiliates/',
      },
      {
        text: 'Nav.BecomeDepopInsider',
        linkAddress: '/partners/depop-insider/',
        locations: [SupportedLocation.US],
      },
      {
        text: 'Nav.DepopTopSellerProgram',
        linkAddress: '/sellers/top-seller-program/',
      },
    ],
  },
  {
    title: 'Nav.Help',
    children: [
      {
        text: 'Nav.HelpCentre',
        linkAddress: HELP_ARTICLES.HELP_HOME,
        asAnchor: true,
      },
      {
        text: 'Nav.SafetyCentre',
        linkAddress: '/safety/',
        locations: SAFETY_CENTRE_LOCALES,
      },
      {
        text: 'Nav.DepopStatus',
        linkAddress: 'https://depopstatus.com/',
      },
    ],
  },
];

export const FooterLowerConfig = [
  {
    text: 'Nav.Sitemaps',
    linkAddress: '/site-map/categories/',
  },
  {
    text: 'Nav.TermsAndConditions',
    linkAddress: HELP_ARTICLES.TERMS_OF_SERVICE,
    asAnchor: true,
  },
  {
    text: 'Nav.Privacy',
    linkAddress: HELP_ARTICLES.PRIVACY_POLICY,
    asAnchor: true,
  },
];
